import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'

import toastStore from '@/stores/toast-store.js'
import axios from 'axios'
import { required } from 'vuelidate/lib/validators'
import formValidator from '@/mixins/form-validator.js'
import PrefixesMixin from '@/mixins/prefixes.js'
import CurrentUserResolver from '@/mixins/current-user-resolver.js'
import AddDeliveryRequestComment from '@/vcs/_shared/modals/add-delivery-request-comment/cmp.vue'

export default {
  name: 'AddDeliveryRequestPhone',
  extends: BaseModal,
  mixins: [formValidator, PrefixesMixin, CurrentUserResolver],
  data: function () {
    return {
      user: {
        phone: '',
        phonePrefix: '',
      },
      errors: {},
      validatedItemKey: 'user',
      submitted: false,
    }
  },
  watch: {
    currentUser: {
      handler: function () {
        this.user.phone = this.currentUser.phone
        this.user.phonePrefix = this.currentUser.phonePrefix
      },
      deep: true,
    },
  },
  methods: {
    fetchCollectomates: function (id) {
      this.blocker = true
      axios({
        method: 'get',
        url: 'collection_points',
      })
        .then(response => {
          this.collectomates = response.data
          this.blocker = false
          console.log('response', response)
        })
        .catch(error => {
          let errorMessage = !!error.response.data.errors
            ? Object.values(error.response.data.errors).join(', ')
            : this.$t('messages.error')
          toastStore.commit('error', { message: errorMessage })
          this.blocker = false
        })
    },

    addPhoneNumber(e) {
      !!e ? e.preventDefault() : null
      this.submitted = true
      this.validateForm()

      if (Object.keys(this.errors).length > 0) {
        toastStore.commit('error', {
          message: this.$t('messages.validationErrorFillFields'),
        })
      } else {
        this.openCommentModal()
      }
    },

    openCommentModal() {
      this.$store.commit('modal/open', {
        cmp: AddDeliveryRequestComment,

        animation: 'slide-left-modal',
        data: {
          collectionPoint: this.data.collectionPoint,
          phonePrefix: this.user.phonePrefix,
          phone: this.user.phone,
        },
      })
    },
  },
  validations() {
    if (this.submitted) {
      return {
        user: {
          phone: {
            required,
          },
          phonePrefix: {
            required,
          },
        },
      }
    } else {
      return {}
    }
  },
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
  },
}
